module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre4"
  }, [_vm._v("Frau Julie Schubert ins Stammbuch")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Ich kam vom Pflug der Erde"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzum Flug ins weite All"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund vom Gebrüll der Herde"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nzum Sang der Nachtigall.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Die Welt hat manche Straße,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nund jede gilt mir gleich,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nob ich ins Erdreich fasse,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nob ins Gedankenreich.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Es wiegt mit gleicher Schwere"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nauf Erden jedes Glied."), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nIhr gebt mir eure Ähre,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\nich gebe euch mein Lied.")]), _vm._v(" "), _c('p', {
    staticClass: "centersml"
  }, [_vm._v("1880")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page15",
      "title": "wedi/Konmax"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "pcalibre pcalibre3 pcalibre1 pcalibre2",
    attrs: {
      "id": "page16",
      "title": "wedi/Konmax"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0